export default __webpack_public_path__ + "static/media/AvenirNextCyr-Light.73aed2dd.eot";